module.exports = __webpack_public_path__ + "static/media/seo.72de4d77.svg";